module.exports = __webpack_public_path__ + "img/41400.cada2af7.jpg";